import React from "react";
import { useDashboard } from './hooks/useDashboard';
import DashboardView from './DashboardView';

// HOC: injects all dashboard logic/state into presentational DashboardView
const Dashboard = () => {
  const dashboardProps = useDashboard();
  return <DashboardView {...dashboardProps} />;
};

export default Dashboard;